// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__0hSo-","cell":"TableRow_cell__kTfax","userId":"TableRow_userId__-gyhY"};